<template>
    <div>
        <!-- 顶部横幅区域 -->
        <div class="banner1">
         <van-icon class="banner1-back" name="arrow-left" size="30px" @click="goBack" />  
     </div>
 
     <div class="bodyconten">
         <div  class="ql-editor"  v-html="richTextContent">
 
         </div>
 
     </div>
     <div class="bottomcontentfa">
         <bottomcontent style="margin:0"></bottomcontent>
       </div>
 
    </div>
   </template>
   
   <script>
    import apiUrls from '@/http/http';
   import 'quill/dist/quill.snow.css';  // 引入 Quill Snow 主题样式
 import 'quill/dist/quill.core.css';  // 引入 Quill 核心样式
 import 'quill/dist/quill.bubble.css'; // （可选）气泡样式
   import bottomcontent from'@/view/h5/public/bottomcontent.vue'
     import CryptoJS from "crypto-js";
      import axios from 'axios';
   export default {
     components:{
           
           bottomcontent
         },
     data() {
       return {
         // 从接口获取的富文本 HTML 字符串
         richTextContent: '',
       };
     },
     created() {
   
      
       this.fetchData();
     },
     methods: {

         async decryptAES(mixedData) {
    try {
        // console.log("🔹 混淆数据:", mixedData);

        // 提取密钥和真实的加密数据
        const insertIndex = 10; // 后端在第 10 个字符后插入密钥
        const encryptedData = mixedData.substring(0, insertIndex) + mixedData.substring(insertIndex + 24); // 24 是 Base64 编码的 AES 密钥长度
        const keyBase64 = mixedData.substring(insertIndex, insertIndex + 24);

        // console.log("🔹 提取出的密钥 (Base64):", keyBase64);
        // console.log("🔹 真实加密数据:", encryptedData);

        // 解析 Base64
        const key = CryptoJS.enc.Base64.parse(keyBase64);
        const cipherText = CryptoJS.enc.Base64.parse(encryptedData);

        // AES-ECB 解密
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: cipherText },
            key,
            { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        );

        if (!decrypted || decrypted.sigBytes <= 0) throw new Error("解密失败，可能密钥错误");

        // 转换为 UTF-8 字符串
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        // console.log("🔹 解密后的文本:", decryptedText);

        if (!decryptedText) throw new Error("解密失败，数据无效");

        // 用正则去掉前面的时间戳及冒号，例如 "1742969450878:" 部分
        const jsonPart = decryptedText.replace(/^\d+:/, "");
        // console.log("🔹 去除前缀后的 JSON 数据:", jsonPart);

       // 将 JSON 字符串转换为对象，并返回
       return JSON.parse(jsonPart);
    } catch (error) {
        console.error("❌ 解密失败:", error.message);
        return null;
    }
},

     

           async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/getmorequestion`, {
                          params: {
                            rute: 'morequestion'
                          }
                        });
               
               const result = await this.decryptAES(response.data.mixedData); 
             
                    if(result) {
                        
                         this.fetchRichText(result);
                      
                    }else{
                        console.log('解密失败')
                    }
                
                   
                
            } catch (error) {
                 // 如果后台返回空数据，则使用默认数据
              
              console.error('后台请求失败，使用默认数据:', error);
            }
        }, 



         goBack() {
       window.history.back(); // 让浏览器返回上一页
     },
       fetchRichText(datas) {
         
          // console.log('原始 数据servicess:', datas);
            // 如果是字符串，先解析成对象
                  let newData;
                  if (typeof datas === 'string') {
                    try {
                      newData = JSON.parse(datas);
                    } catch (e) {
                      console.error('itemss 字符串解析失败:', e);
                      newData = [];
                    }
                  } else if (Array.isArray(datas)) {
                    newData = datas;
                  } else {
                    newData = [];
                  }

            //  console.log('解析后的数据:', newData[0].bodycontenen);

         // 这里仅用 setTimeout 模拟异步请求
         setTimeout(() => {
            this.richTextContent =newData[0].bodycontenen;

                  // 替换掉 8080 端口
     //`${apiUrls.devApi}/dev-api/profile/upload/2025/04/01/1c7332b7-5f5f-4ec0-af2d-36ad1acf8842_20250401121408A001.jpg`
         // 替换掉 /dev-api 为 apiUrls.devApi，确保图片路径完整
         this.richTextContent = this.richTextContent.replace(/src="\/dev-api/g, `src="${apiUrls.devApi}`);
         }, 500);
       }
     }
   };
   </script>
   
   <style scoped>
 
  /* ===== 顶部横幅区域样式 ===== */
 /* 页面顶部的图片背景区域，作为页面的视觉入口 */
 .banner1 {
     /* 背景设置 - 层叠多种背景属性确保视觉效果 */
     background-color: green; /* 设置备用背景颜色，图片加载失败时显示 */
     background-image: url('@/assets/usermore.png'); /* 设置横幅背景图片 */
    
 
      /* 关键属性，确保背景铺满但不变形 */
      background-size: cover; /* 让背景图片填充整个容器，可能裁剪部分 */
      background-position: center; /* 居中对齐，避免偏移 */
      background-repeat: no-repeat; /* 防止图片重复 */
 
     /* 尺寸设置 - 控制横幅的大小 */
     width: 100vw; /* 宽度设置为视口宽度，确保横幅占满屏幕宽度 */
     height: 230px; /* 设置固定高度，与设计稿保持一致 */
     
     /* 间距控制 - 确保没有多余空间 */
     margin: 0; /* 移除外边距，确保紧贴容器边缘 */
     padding: 0; /* 移除内边距，确保内容紧贴边缘 */
 
     /* 定位设置 - 为子元素提供定位上下文 */
     position: relative; /* 建立定位上下文，使 logo 可以相对横幅定位 */
     /* 不设置z-index，让堆叠顺序由DOM顺序决定 */
 }
 .banner1 .banner1-back{
     position: absolute;
     top: 60px;
     left: 10px;
     color: white;
 }
 
 
 /* ===== 主体内容区域样式 ===== */
 /* 页面主要内容的容器，包含所有信息展示和交互元素 */
 .bodyconten {
     /* 外观样式 - 设置主体区域的视觉呈现 */
     border-radius: 30px 30px 0 0; /* 设置上方圆角：左上、右上20px */
     background-color: white; /* 设置白色背景 */
     
     /* 尺寸设置 - 控制主体区域大小 */
     /*  height: 660px;设置固定高度，确保足够的内容空间 */
     min-height: 660px;
     width: 100vw; /* 宽度设置为视口宽度，确保占满屏幕 */
     
     /* 位置控制 - 调整与上方元素的关系 */
     margin-top: -80px; /* 负边距使内容向上偏移，与横幅重叠 */
     
     /* 定位和层级 - 建立层级关系 */
     position: relative; /* 建立定位上下文，为子元素提供定位参考 */
     z-index: 2; /* 设置层级高于横幅，但低于logo */
 
     padding-top: 10px;
 }
 .ql-editor{
     width: 100vw;
 }
 /deep/.ql-editor .ql-align-center img{
     width: 40vw;
     height: auto;
 }
 .bottomcontentfa{
     background-color: white;
 }
 /deep/.bottom2{
    
     
     height: 180px;
 }
   </style>
   